<template>
  <div class="le-icons-input">
    <el-input v-model="iconClass" placeholder="请选择资源" class="le-icons-select" :clearable="clearable" :readonly="readonly" :disabled="disabled">
      <template slot="prepend">
        <slot name="prepend" />
      </template>

      <el-button slot="append" icon="el-icon-search" class="le-icons-search-btn" @click="handleShowIconList" />
    </el-input>

    <icon-list ref="icon_list" :icon-type="iconType" :init-data="initData" :img-render="imgRender" :props="props" @change="handleChangeEvent" />
  </div>
</template>

<script>
import IconList from './icon_list';

export default {
  name: 'LeIconSelect',
  components: {IconList},
  props: {
    value: {
      type: String,
      default: ''
    },
    iconType: {
      type: String,
      default: 'icon'
    },
    initData: {
      type: [Array, Function],
      default: null
    },
    imgRender: {
      type: Function,
      default: (icon) => {
        return icon;
      }
    },
    props: {
      type: Object,
      default: null
    },
    clearable: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconClass: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    handleShowIconList() {
      this.$refs.icon_list.handleShow();
    },
    handleChangeEvent(icon, item) {
      this.iconClass = icon;
      this.$emit('change', icon, item);
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.le-icons-select {

  .el-input-group__prepend {
    background-color: #fff;
  }

  &.el-input--mini {

    .el-input__suffix {
      right: 3px;
    }

    .el-input__icon {
      width: 14px;
    }

    .el-select__caret {
      font-size: 10px;
    }
  }
}

</style>
